import React from "react";
import { Slide, Grid } from "@material-ui/core";

var MobileContainerAnimation = function MobileContainerAnimation(props) {
  if (props.animation) {
    return /*#__PURE__*/React.createElement(Slide, {
      "in": true,
      direction: props.direction
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: props.classes
    }, props.children));
  } else {
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: props.classes
    }, props.children);
  }
};

export { MobileContainerAnimation };